
@use '../../../../../../../styles/Colors.scss' as Colors;
@use '../../../../../../../styles/Constants.scss' as Constants;

.user-full-name{
	margin-right: Constants.$val-spacing-m;
}

.user-per-diem{
	display: flex;
	flex-direction: row;

	.per-diem-amount{
		display: flex;
		flex-direction: row;
		margin-left: Constants.$val-spacing-m;
		align-items: baseline;
		font-weight: normal;

		& [class^="help-"] {
			text-transform: none;
		}

		.per-diem-amount-text{
			font-size: Constants.$val-fontSizeRegular;
			text-transform: none;
			margin-left: Constants.$val-spacing-s;
		}
	}

	.per-diem-amount-input-field {
		border: 1px solid Colors.$col-greyMid;
		border-radius: Constants.$val-borderRadius;
		background-color: Colors.$col-white;
		font-size: Constants.$val-fontSizeRegular;
		line-height: Constants.$val-lineHeightRegular;
		outline: none;
	}

	.per-diem-readonly {
		font-size: Constants.$val-fontSizeRegular;
		margin-top: auto;
		margin-bottom: auto;
		font-weight: normal;

		&__text{
			color: Colors.$color-green;
			font-weight: bold;
			margin-right: Constants.$val-spacing-xs;
		}
	}
}